import React from 'react';
import { Box, Button } from '@chakra-ui/react';
import FormInput from '../../../../components/forms/FormInput';
import FormTextarea from '../../../../components/forms/FormTextarea';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import { DiscordRoleForm } from '../constants';
import { useNavigate } from 'react-router-dom';
import { ADMIN_DISCORD_ROLES_PATH } from '../../../../routing/constants';
import { discordRoleCreateSchema } from '../yup/discordRoleCreateSchema';
import { useEditDiscordRole } from '../../../../hooks/discord/useEditDiscordRole';
import { DiscordRole } from '../../../../types/DiscordRole';

interface FormProps {
  discordRole: DiscordRole;
}

const DiscordRoleEditForm: React.FC<FormProps> = ({ discordRole }) => {
  const mutation = useEditDiscordRole();
  const navigate = useNavigate();
  const {
    handleSubmit,
    register,
    setValue,
    getValues,
    formState: { errors, isValid },
  } = useForm<DiscordRoleForm>({
    resolver: yupResolver(discordRoleCreateSchema),
    defaultValues: {
      name: discordRole.name,
      emoji: discordRole.emoji,
    },
  });

  const onSubmit = async (data: DiscordRoleForm) => {
    try {
      await mutation.mutateAsync({ id: discordRole.id, discordRole: data });
      toast.success('Role édité avec succes', {
        position: toast.POSITION.TOP_CENTER,
      });
      navigate(ADMIN_DISCORD_ROLES_PATH);
    } catch (error: any) {
      toast.error(`Échec d'update du role : ${error.response.data.message}`, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box mt={4}>
        <FormInput variant="whiteBorderNoBg" label={'Nom'} placeholder="Nom" type="text" name="name" required register={register} errors={errors} />
      </Box>
      <Box mt={4}>
        <FormTextarea variant="whiteBorderNoBg" label={'Emoji'} placeholder="Emoji" name="emoji" required register={register} errors={errors} getValues={getValues} setValue={setValue} />
      </Box>
      <Box my={4} textAlign="right">
        <Button variant="navYellow" type="submit" isLoading={mutation.isLoading} isDisabled={!isValid}>
          Enregistrer
        </Button>
      </Box>
    </form>
  );
};

export default DiscordRoleEditForm;
